module.exports = __webpack_public_path__ + "img/recette_du_chef.2d6df344.png";